<template>
  <div v-if="containerClientDomain === currentClientDomain || !isGlobalMode"
       :id="'scheduleTableContainer_' + containerClientDomain">
    <!--    {{containerClientDomain}} | {{currentClientDomain}}-->
    <div v-if="isTablesLoaded"
         class="header">
      <div class="row expanded table-menu-container">
        <div class="small-12">
          <div class="row expanded label-row">
            <div class="small-6 medium-3">{{ trans.dateText }}</div>
            <div class="small-6 medium-3 columns">{{ trans.subjectTypeText }}</div>
          </div>
          <div class="row expanded align-middle data-row">
            <div class="small-6 medium-3 ">
              <!-- date filter -->
              <div class="ui form" v-if="!$store.getters.isDigitalMode">
                <div class="field">
                  <!--
                                  <input type="date" v-model="currentTableDate" @change="dateChanged">
                  -->
                  <date-picker v-model="currentTableDate"
                               :clearable="false"
                               :editable="false"
                               :first-day-of-week="1"
                               :lang="DATE_PICKER_LANG"
                               :not-before="today"
                               @change="dateChanged"></date-picker>
                </div>
              </div>
              <!-- ./date filter -->
            </div>
            <div class="small-6 medium-3 columns">
              <!-- subject type filter -->
              <!-- helper to initialize value -->
              {{ setCurrentSubjectTypeID }}
              <!-- ./helper -->
              <!--<div v-show="subjectTypes.length > 1" class="ui form">-->
              <div v-if="subjectTypes.length > 1"
                   class="ui form">
                <div class="field">
                  <select v-model="currentSubjectTypeID"
                          @change="subjectTypeChanged">
                    <option v-for="subjectType in subjectTypes"
                            :value="subjectType.ID">{{ subjectType.subjectType }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="subjectTypes.length === 1">
                <div>{{ subjectTypes[0].subjectType }}</div>
              </div>
              <!-- ./subject type filter -->
            </div>
            <div class="small-6 medium-3 columns">
              <button class="ui button reservation-rule-button"
                      @click="openReservationRules">
                <i class="check icon"></i>
                {{ trans.reservationRulesText }}
              </button>
            </div>
            <div class="small-6 medium-3 columns">
              <button class="ui button resign-rule-button"
                      @click="openResignRules">
                <i class="close icon"></i>
                {{ trans.resignRulesText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isTablesLoaded"
         class="content">
      <div class="schedule-container"> <!-- :style="getScheduleContainerStyle" -->
        <guest-schedule v-if="tables.length > 0"
                        :is-logged-in="isLoggedIn"
                        :is-mobile-device="isMobileDevice"
                        :table-date="getCurrentTableDate"
                        :tables="tables"
                        @changeCurrentTableDate="changeCurrentTableDate"
                        @create-new-reservation="createNewReservation"
                        @resign-reservation="resignReservation"
        />
        <div v-else
             class="no-result-placeholder">
          <div>
            <i class="ban icon"></i>
            <h2>{{ trans.noTableHeaderMain }}</h2>
            <h3>{{ trans.noTableHeaderSub }}</h3>
          </div>
        </div>
      </div>
    </div>
    <schedule-legend v-if="isTablesLoaded && tables.length > 0"/>

    <div v-if="!isTablesLoaded"
         class="spinner-container">
      <!-- :loading="loading" :color="color" :size="size" -->
      <pulse-loader color="#d6d6d6"></pulse-loader>
    </div>
  </div>
</template>

<script>
import GuestSchedule from './GuestSchedule.vue'
import ScheduleLegend from './Legend'
import moment from 'moment'
import notify from '../../notify'
import DatePicker from 'vue2-datepicker'
import {mapState} from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  props: ['isLoggedIn', 'isMobileDevice', 'containerClientDomain'],
  data () {
    return {
      currentTableDate: this.$store.state.currentTableDate,
      currentSubjectTypeID: this.$store.state.currentSubjectTypeID,
      dateTestData: '',
      today: moment().format('YYYY-MM-DD'),
      DATE_PICKER_LANG: this.$store.state.DATE_PICKER_LANG,
    }
  },
  methods: {
    createNewReservation (resData) {
      // this.$parent.$parent.$emit('create-new-reservation', resData)
      this.$emit('create-new-reservation', resData)
    },
    resignReservation (data) {
      // this.$parent.$parent.$emit('resign-reservation', data)
      this.$emit('resign-reservation', data)
    },
    someThg () {
      console.log(';)')
    },
    dateChanged () {
      if (moment.isDate(this.currentTableDate)) {
        this.$store.dispatch('setCurrentTableDate', {
          currentTableDate: moment(this.currentTableDate).format('YYYY-MM-DD'),
        })
        this.$store.dispatch('fetchTable');
      } else {
        notify.warning('Adj meg egy helyes dátumot!')
        // this.currentTableDate = moment().format('YYYY-MM-DD')
      }
    },
    subjectTypeChanged () {
      this.$store.dispatch('setCurrentSubjectType', { currentSubjectTypeID: this.currentSubjectTypeID })
      this.$store.dispatch('fetchTable');
    },
    openReservationRules () {
      let resRulesText = ''
      let resRulesHtml = ''
      let currentClientDomain = this.isGlobalMode ? this.$store.state.currentClientDomain : this.$store.state.ownerDomain
      let clients = this.$store.state.clients
      console.log(clients)
      let config

      for (let i in clients) {
        let client = clients[i]
        if (client.domain === currentClientDomain) {
          // eslint-disable-next-line no-prototype-builtins
          if (client.hasOwnProperty('reservationPolicy')) {
            resRulesText = client.reservationPolicy
          }
          // eslint-disable-next-line no-prototype-builtins
          if (client.hasOwnProperty('config')) {
            config = client.config
          }
        }
      }
      // eslint-disable-next-line no-prototype-builtins
      if (config && config.hasOwnProperty('reservation_daily_limit') && config.hasOwnProperty('reservation_weekly_limit')) {
        resRulesHtml =
          `<p>${resRulesText}</p>
        <div style="text-align: left;">
         <h5>Aktív felhasználói limitek</h5>
         ${config.payment ? '<ul><li>Online fizetés esetén a foglalást ' + config.paymentStartKeepUpMin + ' percig tartjuk fent</li></ul>' : ''}
         <h5>Vendég</h5>
         <ul>
          <li>Napi foglalási limit: ${config.reservation_daily_limit.guest || '-'}</li>
          <li>Heti foglalási limit: ${config.reservation_weekly_limit.guest || '-'}</li>
          ${(config.reservation_max_ahead.guest === false || config.reservation_max_ahead.guest === 0)
            ? '<li>A foglalás a vendégeknek jelenleg zárolva van.</li>'
            : (config.reservation_max_ahead.guest !== true && Number(config.reservation_max_ahead.guest))
              ? '<li>' + config.reservation_max_ahead.guest + ' nappal előre foglalhatsz</li>' : ''}
         </ul>
         <h5>Edző</h5>
         <ul>
          <li>Napi foglalási limit: ${config.reservation_daily_limit.trainer || '-'}</li>
          <li>Heti foglalási limit: ${config.reservation_weekly_limit.trainer || '-'}</li>
          ${(config.reservation_max_ahead.trainer === false || config.reservation_max_ahead.trainer === 0)
            ? '<li>A foglalás az edzőknek jelenleg zárolva van.</li>'
            : (config.reservation_max_ahead.trainer !== true && Number(config.reservation_max_ahead.trainer))
              ? '<li>' + config.reservation_max_ahead.trainer + ' nappal előre foglalhatsz</li>' : ''}
         </ul>
       </div>`
      }

      // notify.info(resRulesText)
      notify.htmlInfo('Foglalási rend', resRulesHtml)
    },
    openResignRules () {
      let resignRulesText = ''
      let resignRulesHtml = ''
      let currentClientDomain = this.isGlobalMode ? this.$store.state.currentClientDomain : this.$store.state.ownerDomain
      let clients = this.$store.state.clients
      let config

      for (let i in clients) {
        let client = clients[i]
        if (client.domain === currentClientDomain) {
          // eslint-disable-next-line no-prototype-builtins
          if (client.hasOwnProperty('resignPolicy')) {
            resignRulesText = client.resignPolicy
          }
          // eslint-disable-next-line no-prototype-builtins
          if (client.hasOwnProperty('config')) {
            config = client.config
          }
        }
      }

      // eslint-disable-next-line no-prototype-builtins
      if (config && config.hasOwnProperty('free_resign_offset') && config.hasOwnProperty('payment_zone')) {
        resignRulesHtml =
          `<p>${resignRulesText}</p>
       <div style="text-align: left;">
         <h5>Ingyenes lemondási szabályok</h5>
         <h5>Vendég</h5>
         <ul>
          <li>A foglalás után ${config.free_resign_offset.guest || '-'} percig ingyenesen lemondható az időpont.</li>
          <li>Az időpont megkezdése előtt legalább ${config.payment_zone.guest || '-'} órával korábban ingyenesen lemondható a foglalás</li>
         </ul>
         <h5>Edző</h5>
         <ul>
          <li>A foglalás után ${config.free_resign_offset.trainer || '-'} percig ingyenesen lemondható az időpont.</li>
          <li>Az időpont megkezdése előtti legalább ${config.payment_zone.trainer || '-'} órával korábban ingyenesen lemondható a foglalás</li>
         </ul>
         <p>Minden egyéb esetben a foglalás után járó összeg levonásra kerül a felhasználó egyenlegből vagy bérletéből.</p>
       </div>`
      }

      // notify.info(resRulesText)
      notify.htmlInfo('Foglalási rend', resignRulesHtml)
    },
    changeCurrentTableDate (date) {
      this.currentTableDate = moment(date).format('YYYY-MM-DD')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.scheduleTableContainer,
    }),
    tables () {
      return this.$store.state.tables
    },
    isTablesLoaded () {
      return !this.$store.state.isLoading.tables
    },
    subjectTypes () {
      return this.$store.state.subjectTypes
    },
    // TODO: Fix this error, no return var !!!
    // eslint-disable-next-line vue/return-in-computed-property
    setCurrentSubjectTypeID () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currentSubjectTypeID = this.$store.state.currentSubjectTypeID
    },
    getCurrentTableDate () {
      return this.$store.state.currentTableDate
    },
    getScheduleContainerStyle () {
      let maxHeight = 0
      let maxTimeCount = 0
      if (this.tables.length > 0) {
        for (let table of this.tables) {
          if (maxTimeCount < table.times.length) {
            maxTimeCount = table.times.length
          }
        }
        maxHeight = (1.7 * maxTimeCount + 8)
      }
      return { 'max-height': '' + maxHeight + 'rem' }
    },
    isClientSelected () {
      return !!this.$store.state.currentClientDomain
    },
    currentClientDomain () {
      return this.$store.state.currentClientDomain
    },
    isGlobalMode () {
      return this.$store.state.isGlobalMode
    },
  },
  mounted: () => {
    /* eslint-disable */
    /*
    if (this.isMobileDevice) {
      let scheduleContainerID = '#scheduleTableContainer_' + this.currentClientDomain()
      $('html, body').animate({
        scrollTop: ($(scheduleContainerID).offset().top - 50)
      }, 500)
    }
    */
  },
  components: {
    GuestSchedule,
    ScheduleLegend,
    DatePicker,
    PulseLoader,
  },
}
</script>

<style scoped>
.label-copy {
  display: block;
  margin: 0 0 .28571429rem 0;
  color: rgba(0, 0, 0, .87);
  font-weight: 700;
  text-transform: none;
  font-size: 110%;
}

input, select {
  border-radius: 0 !important;
}

.schedule-container {
  /*min-height: 17rem;*/
  height: auto;
}

.ui.button {
  margin-top: 3%;
  border-radius: 0;
}

.spinner-container {
  height: 4rem;
  width: 4rem;
  margin-left: auto;
  margin-right: auto;
  padding: 1.5rem 0;
}

.table-menu-container {
  margin-top: .5rem;
}

.label-row {
  background: #ededed;
  padding: 0.5rem 1rem;
  font-size: 120%;
}

.data-row {
  background: #d6d6d6;
  padding: 0 1rem;
}

.reservation-rule-button {
  background: #889b7f;
}

.reservation-rule-button:hover {
  background: #889b7f;
  opacity: .7;
}

.resign-rule-button {
  background: #957777;
}

.resign-rule-button:hover {
  background: #957777;
  opacity: .7;
}

</style>
